import {ApiResponse, ListQueryParams} from '../ApiClient'
import {GetAPIDomain, GetAPIHeaders, GetAPIHeadersPatch, GetApiHeadersFormData} from '../Helper'

export class SiteQueryParams extends ListQueryParams {
  WithUserId(value: string) {
    this.WithParam('userId', value)
    return this
  }

  WithSiteTypeId(value: string) {
    this.WithParam('siteTypeId', value)
    return this
  }

  WithStatus(value: string) {
    this.WithParam('status', value)
    return this
  }

  WithDate(value: boolean) {
    this.WithParam('date', value)
    return this
  }

  WithNoticeId(value: string) {
    this.WithParam('noticeId', value)
    return this
  }

  WithCafeOnly(value: boolean) {
    this.WithParam('cafeOnly', value)
    return this
  }

  WithParkingOnly(value: boolean) {
    this.WithParam('parkingOnly', value)
    return this
  }

  WithForTicketCategoryId(value: string) {
    this.WithParam('forTicketCategoryId', value)
    return this
  }

  WithIsForManagedEventsOnly(value: boolean) {
    this.WithParam('isForManagedEventsOnly', value)
    return this
  }

  WithHasProjectOnly(value: boolean) {
    this.WithParam('hasProjectOnly', value)
    return this
  }
}

export class SitesClient {
  static async List(params: SiteQueryParams) {
    var query = (await GetAPIDomain()) + '/sites' + params.GenerateQueryString()

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      })
    )
  }

  static async LookUp(params: SiteQueryParams) {
    var query = (await GetAPIDomain()) + '/sites/lookup' + params.GenerateQueryString()

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      })
    )
  }

  static async GetSummary(id: string, month: number, year: number) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/sites/monthly-summary' + `?id=${id}&month=${month}&year=${year}`, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      })
    )
  }

  static async Delete(id: string) {
    var query = (await GetAPIDomain()) + '/sites/' + id

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        method: 'DELETE',
        credentials: 'include',
      })
    )
  }

  static async Get(id: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/sites/' + id, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      })
    )
  }

  static async Create(
    name: string,
    latitude: string,
    longitude: string,
    address1: string,
    address2: string,
    address3: string,
    city: string,
    state: string,
    country: string,
    postcode: string,
    status: string,
    color: string,
    isDefault: boolean,
    isCafeAvailable: boolean,
    siteTypeId?: any,
    maxLimit?: number | null,
    startTime?: any,
    endTime?: any,
    isParkingAvailable?: boolean,
    isLockerAvailable?: boolean,
    allowBookings?: boolean,
    isParkingIntegrationEnabled?: boolean,
    isForManagedEvents?: boolean
  ) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/sites/', {
        method: 'POST',
        credentials: 'include',
        headers: GetAPIHeaders(),
        body: JSON.stringify({
          name: name,
          latitude: latitude,
          longitude: longitude,
          address1: address1,
          address2: address2,
          address3: address3,
          city: city,
          state: state,
          country: country,
          postcode: postcode,
          status: status,
          siteTypeId: siteTypeId,
          maxLimit,
          color,
          isDefault,
          isCafeAvailable,
          startTime,
          endTime,
          isParkingAvailable,
          isLockerAvailable,
          allowBookings,
          isParkingIntegrationEnabled,
          isForManagedEvents,
        }),
      })
    )
  }

  static async Update(
    id: string,
    name: string,
    latitude: string,
    longitude: string,
    address1: string,
    address2: string,
    address3: string,
    city: string,
    state: string,
    country: string,
    postcode: string,
    status: string,
    color: string,
    isDefault: boolean,
    isCafeAvailable: boolean,
    siteTypeId?: any,
    maxLimit?: number | null,
    startTime?: any,
    endTime?: any,
    isParkingAvailable?: boolean,
    isLockerAvailable?: boolean,
    allowBookings?: boolean,
    isParkingIntegrationEnabled?: boolean,
    isForManagedEvents?: boolean
  ) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/sites/' + id, {
        method: 'PATCH',
        credentials: 'include',
        headers: GetAPIHeadersPatch(),
        body: JSON.stringify([
          {
            op: 'replace',
            path: 'name',
            value: name,
          },
          {
            op: 'replace',
            path: 'latitude',
            value: latitude,
          },
          {
            op: 'replace',
            path: 'longitude',
            value: longitude,
          },
          {
            op: 'replace',
            path: 'address1',
            value: address1,
          },
          {
            op: 'replace',
            path: 'address2',
            value: address2,
          },
          {
            op: 'replace',
            path: 'address3',
            value: address3,
          },
          {
            op: 'replace',
            path: 'city',
            value: city,
          },
          {
            op: 'replace',
            path: 'state',
            value: state,
          },
          {
            op: 'replace',
            path: 'country',
            value: country,
          },
          {
            op: 'replace',
            path: 'postcode',
            value: postcode,
          },
          {
            op: 'replace',
            path: 'status',
            value: status,
          },
          {
            op: 'replace',
            path: 'siteTypeId',
            value: siteTypeId,
          },
          {
            op: 'replace',
            path: 'maxLimit',
            value: maxLimit,
          },
          {
            op: 'replace',
            path: 'color',
            value: color,
          },
          {
            op: 'replace',
            path: 'isDefault',
            value: isDefault,
          },
          {
            op: 'replace',
            path: 'isCafeAvailable',
            value: isCafeAvailable,
          },
          {
            op: 'replace',
            path: 'startTime',
            value: startTime,
          },
          {
            op: 'replace',
            path: 'endTime',
            value: endTime,
          },
          {
            op: 'replace',
            path: 'isParkingAvailable',
            value: isParkingAvailable,
          },
          {
            op: 'replace',
            path: 'isLockerAvailable',
            value: isLockerAvailable,
          },
          {
            op: 'replace',
            path: 'allowBookings',
            value: allowBookings,
          },
          {
            op: 'replace',
            path: 'isParkingIntegrationEnabled',
            value: isParkingIntegrationEnabled,
          },
          {
            op: 'replace',
            path: 'isForManagedEvents',
            value: isForManagedEvents,
          },
        ]),
      })
    )
  }

  static async UploadSiteImage(siteId: string, file: any) {
    let formData = new FormData()
    formData.append('file', file)

    var accessToken = localStorage.getItem('acess-token')

    const response = await fetch((await GetAPIDomain()) + '/sites/upload-site-image/' + siteId, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({Authorization: 'Bearer ' + accessToken}),
      body: formData,
    })

    if (!response.ok) {
      return false
    }

    const data = await response.json()
  }

  static async BulkUpload(siteTypeId: string, file: any) {
    let formData = new FormData()
    formData.append('siteTypeId', siteTypeId)
    formData.append('file', file)
    var apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/sites/bulk', {
        credentials: 'include',
        method: 'POST',
        headers: GetApiHeadersFormData(),
        body: formData,
      })
    )
  }

  static async SetDaysOfWeek(id: string, validDays: any[]) {
    var apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/sites/' + id + '/days-of-week', {
        method: 'POST',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({validDays}),
      })
    )
  }
}
